import React from 'react'
import ImageGallery from 'react-image-gallery'
import './Gallery.css'
import LazyLoad from 'react-lazy-load'
import useImageLightBox from 'hooks/Lightbox/useImageLightBox'
import ImageViewer from 'components/TailedImage'
const Gallery = (props) => {
    const { data, path } = props
    const fetchImages = (data, path) => {
        var imagesList = []
        var images = data.img_path
        if (Array.isArray(images)) {
            for (var i = 0; i < images.length; i++) {
                if (typeof images[i] !== 'string') continue;
                var imgPath = images[i].startsWith("results/") ? images[i].substring(8) : images[i];
                imagesList.push(path + imgPath)
            }
        } else if (typeof images === 'string') {
            var imgPath = images.startsWith("results/") ? images.substring(8) : images;
            imagesList.push(path + imgPath)
        }
        return imagesList
    }

    if (data == null) return null
    if (data.img_path !== undefined) {
        var imagesList = fetchImages(data, path)
        if (imagesList.length === 0) return null
        return (
            <div className="py-2">
                <LazyLoad offset={300}>
                    <ImageViewer images={imagesList} />
                    {/* <ImageGallery
                        items={imagesList}
                        lazyLoad
                        // showThumbnails={false}
                        thumbnailPosition="left"
                        showPlayButton={false}
                        useBrowserFullscreen={false}
                        
                    /> */}
                </LazyLoad>
            </div>
        )
    } else if (data.data_path !== undefined) {
        return null
    }
    return null
}

export default Gallery
